import React from 'react'

const Help = () => {
  return (
    <div className="text-6xl font-bold">
        Help
    </div>
  )
}

export default Help